import { result, stringify } from '../shared';

export const key = 'email';

export const meta = {
  label: 'Email Address',
  sensitive: false,
  allowed_contact_types: ['string'],
  allowed_form_types: ['Text'],
};

const EMAIL_RGX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validate(value) {
  const email = stringify(value).toLowerCase();
  if (!email) {
    return result(false, '', 'Email address is required');
  }
  if (!EMAIL_RGX.test(email)) {
    return result(false, email, 'Email address is invalid');
  }
  return result(true, email);
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : stringify(value).toLowerCase();
}

export function display(value) {
  const res = validate(value);
  return res.valid ? res.value : stringify(value);
}

export function getInputProps() {
  return {
    type: 'email',
    maxlength: 320,
  };
}
